export default "__VITE_ASSET__4498a1e8__"